import { message } from 'antd';

import { select, call, put, takeEvery, takeLatest, all, fork } from 'redux-saga/effects'
import { history } from "../../../appRedux/store";
import { saveDictationAudioAPI, submitVisitReportDictationAPI } from '../../../services/patient-visits-service';

import { lockVisitAPI, unlockVisitAPI } from '../../../services/locked-visits-service';
import { updateVisitReportStateAPI, getPatientHistoryReportsAPI, getVisitReportAPI, getWorklistAutoNextVisitAPI, getsubmittedForVerificationAutoNextVisitAPI, getAutoNextParkedVisitAPI, assignedMis2API, unassignMis1API, openVoyagerAPI, closeVoyagerAPI } from "../../../services/mis-service";

import { setUnsavedChanges, SET_UNSAVED_CHANGES, SET_VISIT_LOCK } from '../../actions/activityAction';

import {
    RESET_REVIEWING_REPORT,

    VIEW_WORKLIST_VISIT,
    VIEW_WORKLIST_VISIT_START,
    VIEW_WORKLIST_VISIT_SUCCESS,
    VIEW_WORKLIST_VISIT_ERROR,

    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR,

    VIEW_PARKED_VISIT,
    VIEW_PARKED_VISIT_START,
    VIEW_PARKED_VISIT_SUCCESS,
    VIEW_PARKED_VISIT_ERROR,

    VIEW_SUBMITTED_TO_TYPIST_VISIT,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS,

    FETCH_PATIENT_HISTORY_REPORTS,
    FETCH_PATIENT_HISTORY_REPORTS_START,
    FETCH_PATIENT_HISTORY_REPORTS_ERROR,
    FETCH_PATIENT_HISTORY_REPORTS_SUCCESS,

    UNLOCK_VISIT,
    UNLOCK_VISIT_ERROR,
    UNLOCK_VISIT_START,
    UNLOCK_VISIT_SUCCESS,

    UPDATE_VISIT_REPORT_STATE,
    UPDATE_VISIT_REPORT_STATE_START,
    UPDATE_VISIT_REPORT_STATE_SUCCESS,
    UPDATE_VISIT_REPORT_STATE_ERROR,

    SAVE_VISIT_REPORT_DICTATION,
    SAVE_VISIT_REPORT_DICTATION_SUCCESS,
    SUBMIT_VISIT_REPORT_DICTATION,
    SUBMIT_VISIT_REPORT_DICTATION_SUCCESS,

    resetReviewingReport,
    SKIP_CURRENT_AND_VIEW_NEXT_VISIT,
    VIEW_VERIFIED_VISIT,
    VIEW_VERIFIED_VISIT_START,
    VIEW_VERIFIED_VISIT_SUCCESS,
    VIEW_VERIFIED_VISIT_ERROR,
    SUBMIT_VISIT_REPORT_DICTATION_ERROR,
    SUBMIT_VISIT_REPORT_DICTATION_START,

    ASSIGN_MIS2_TO_VISIT,
    assignedMis2,
    ASSIGN_MIS2_TO_VISIT_SUCCESS,
    ASSIGN_MIS2_TO_VISIT_ERROR,
    UNASSIGN_MIS1,
    UNASSIGN_MIS1_START,
    UNASSIGN_MIS1_ERROR,
    UNASSIGN_MIS1_SUCCESS,
    SAVE_DICTATION_AUDIO_SUCCESS,
    SAVE_DICTATION_AUDIO_ERROR,
    SAVE_DICTATION_AUDIO,
    SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
    UPDATE_STUDY,
    UPDATE_STUDY_SUCCESS,
    LOCK_VERIFIED_VISIT,
    LOCK_VERIFIED_VISIT_START,
    LOCK_VERIFIED_VISIT_ERROR,
    OPEN_VOYAGER_STUDY, 
    CLOSE_VOYAGER_STUDY
} from "../../actions/mis/reportViewerAction";
import { REMOVE_LOCKED_VISIT } from '../../actions/mis/worklistAction';
import { TICKET_DETAILS_RESET } from '../../actions/ticketing/ticketActions';
import { setSessionDataByKey, SET_USER_SESSION_DATA_BY_KEY } from '../../actions/userLocalStorageSession';
import { loadOrder } from '../../actions/integratorActions';
import { IMAGE_VIEWERS, VISIT_STATES } from '../../../constants/constants';
import { VIEW_SFV_VISIT_LOADING_END, VIEW_SFV_VISIT_LOADING_START } from '../../actions/mis/submittedForVerificationAction';
import { VIEW_PARKED_VISIT_LOADING_START, VIEW_PARKED_VISIT_LOADING_END } from '../../actions/mis/parkedAction';
import { VIEW_STT_VISIT_LOADING_END, VIEW_STT_VISIT_LOADING_START } from '../../actions/mis/submittedToTypistAction';
import { VIEW_VERIFIED_VISIT_LOADING_END, VIEW_VERIFIED_VISIT_LOADING_START } from '../../actions/mis/verifiedAction';
import { updateStudyAPI } from '../../../services/group-admin-service';
import { HIDE_MODAL, SUBMIT_ERROR, SUBMIT_START } from '../../actions';


const initialSearch = {
    searchFilter: {
        searchText: "",
        sites: [],
        modalities: []
    },
    sortConditions: []
};

const getIntegratorState = (state) => state.integrator;
const getWorklistState = (state) => state.mis.worklist;
const getSubmittedForVerificationState = (state) => state.mis.submittedForVerification;
const getParkedState = (state) => state.mis.parked;
const getReportViewerState = (state) => state.mis.reportViewer;
const getAuthUserState = (state) => state.auth.authUser;
const getUserConfigurationsState = (state) => state.auth.configurations;

function* shouldAutoLaunchViewerOnSfv() {
    const configurations = yield select(getUserConfigurationsState);
    return !configurations || configurations.auto_launch_iv_sfv !== false;
}
const getSessionDataState = (state) => state.auth.sessionData;
const getRoutingLocation = (state) => state.routing.location;
// const getRisUsersState = (state) => state.auth.authUser.risUserMips;

// function* getRisUserNameForRisId(risId) {
//     try {
//         const risUsers = yield select(getRisUsersState);
//         if (risUsers.length > 0) {
//             const risUser = risUsers.find(user => user.risId === risId);
//             if (risUser) {
//                 return risUser.userName;
//             }
//             message.error("Ris user not found for ris id:" + risId);
//             return null;
//         }
//         message.error("Ris users not found!");
//         return null;
//     } catch (error) {
//         console.log(error);
//     }
// }

function* setVisitLock(visit) {
    if (visit !== null) {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: true,
                reportId: visit.reportId
            }
        })
    } else {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: false,
                reportId: null
            }
        })
    }
}

function* lockVerifiedVisit({ report, enableCkEditor }) {
    yield put({
        type: LOCK_VERIFIED_VISIT_START,
    })
    const response = yield lockVisitAPI(report.reportId);
    if (response.success) {
        const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
        if (visitReportResponse.success) {
            yield put({
                type: VIEW_VERIFIED_VISIT_SUCCESS,
                report: {
                    ...visitReportResponse.visitReport
                }
            })
            enableCkEditor();
            const data = {
                risId: report.risId,
                patientId: report.pid,
                accessionNum: report.visitNo,
                mipId: report.mipId
            }
            yield call(viewImages, data);
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: true,
                    reportId: report.reportId
                }
            })           
        } else {
            message.error('Failed to lock visit!');
        }
    } else {
        yield put({ type: LOCK_VERIFIED_VISIT_ERROR })
        message.error('Visit is locked by other user!');
    }
}

function* viewWorklistVisit({ report, stayOnViewer }) {
    try {
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({
            type: VIEW_WORKLIST_VISIT_START,
            report
        })
        // const risUserName = yield getRisUserNameForRisId(report.risId);
        const { userId } = yield select(getAuthUserState);
        const { pathname } = yield select(getRoutingLocation);
        if (!stayOnViewer) {
            history.push({
                pathname: '/mis/report-viewer',
                state: {
                    from: pathname,
                    preopenDefaultViewer: true
                }
            });
        }

        if (report.state === VISIT_STATES.P) {
            const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
            if (visitReportResponse.success) {
                yield put({
                    type: VIEW_WORKLIST_VISIT_SUCCESS,
                    report: {
                        ...visitReportResponse.visitReport
                    }
                })
                const data = {
                    risId: report.risId,
                    patientId: report.pid,
                    accessionNum: report.visitNo,
                    mipId: report.mipId
                }
                yield call(viewImages, data);
                yield call(setVisitLock, null);
            } else {
                yield put({ type: VIEW_WORKLIST_VISIT_ERROR })
                message.error('Failed to view visit!');
            }
        } else if (report.lockedBy == null) {
            const response = yield lockVisitAPI(report.reportId);
            if (response.success) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_WORKLIST_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport
                        }
                    })

                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    yield call(viewImages, data);
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: VIEW_WORKLIST_VISIT_ERROR })
                message.error('Visit is locked by other user!');
            }
        } else {
            if (report.lockedBy === userId) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_WORKLIST_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    yield call(viewImages, data);
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: REMOVE_LOCKED_VISIT, report })
                message.error({ content: 'You are not allowed access this visit!', key: 'locked-visit-validation-2' });
            }
        }
    } catch (error) {
        yield put({ type: VIEW_WORKLIST_VISIT_ERROR, error })
        message.error('Failed to view visit!');
    }
}

function* viewSubmittedForVerificationVisit({ report }) {
    try {
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_SFV_VISIT_LOADING_START })
        // const risUserName = yield getRisUserNameForRisId(report.risId);
        const { userId } = yield select(getAuthUserState);
        const { pathname } = yield select(getRoutingLocation);

        if (report.lockedBy == null) {
            const response = yield lockVisitAPI(report.reportId);
            if (response.success) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    const autoLaunchViewer = yield call(shouldAutoLaunchViewerOnSfv);
                    if(autoLaunchViewer && visitReportResponse.visitReport.visit.mis1 === null){
                        yield call(viewImages, data);
                    }
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mis/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR })
                message.error('Visit is locked by other user!');
            }
            yield put({ type: VIEW_SFV_VISIT_LOADING_END })
        } else {
            if (report.lockedBy === userId) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    const autoLaunchViewer = yield call(shouldAutoLaunchViewerOnSfv);
                    if(autoLaunchViewer && visitReportResponse.visitReport.visit.mis1 === null){
                        yield call(viewImages, data);
                    }
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mis/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: REMOVE_LOCKED_VISIT, report })
                message.error({ content: 'You are not allowed access this visit!', key: 'locked-visit-validation-2' });
            }
            yield put({ type: VIEW_SFV_VISIT_LOADING_END })
        }
    } catch (error) {
        yield put({ type: VIEW_SFV_VISIT_LOADING_END })
        yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error })
        message.error('Failed to update report status to draft!');
    }
}

function* viewParkedVisit({ report }) {
    try {
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_PARKED_VISIT_LOADING_START })

        const { userId } = yield select(getAuthUserState);
        const { pathname } = yield select(getRoutingLocation);

        if (report.lockedBy != null && report.lockedBy !== userId) {
            yield put({ type: REMOVE_LOCKED_VISIT, report })
            message.error({ content: 'You are not allowed access this visit!', key: 'locked-visit-validation-2' });
        } else {
            yield put({ type: VIEW_PARKED_VISIT_START })
            const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
            const vr = visitReportResponse.visitReport;
            const hasUsableReport = !!(vr && vr.visit);
            if (visitReportResponse.success && hasUsableReport) {
                yield put({ type: VIEW_PARKED_VISIT_SUCCESS, report: { ...vr } })
                if (report.lockedBy === userId) {
                    yield call(setVisitLock, report);
                } else {
                    yield call(setVisitLock, null);
                }
                history.push({ pathname: '/mis/report-viewer', state: { from: pathname } });
            } else if (visitReportResponse.success && !hasUsableReport) {
                yield put({ type: VIEW_PARKED_VISIT_ERROR, error: null });
                message.info('Report not found for this visit.');
            } else {
                yield put({ type: VIEW_PARKED_VISIT_ERROR, error: visitReportResponse.error })
                message.error('Failed to view parked visit!');
            }
        }
        yield put({ type: VIEW_PARKED_VISIT_LOADING_END })
    } catch (error) {
        yield put({ type: VIEW_PARKED_VISIT_LOADING_END })
        yield put({ type: VIEW_PARKED_VISIT_ERROR, error })
        message.error('Failed to view parked visit!');
    }
}


function* viewVerifiedVisit({ report }) {
    try {
        const { pathname } = yield select(getRoutingLocation);
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_VERIFIED_VISIT_START })
        yield put({ type: VIEW_VERIFIED_VISIT_LOADING_START })
        const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
        if (visitReportResponse.success) {
            yield put({
                type: VIEW_VERIFIED_VISIT_SUCCESS,
                report: {
                    ...visitReportResponse.visitReport
                }
            })
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            history.push({
                pathname: '/mis/report-viewer',
                state: {
                    from: pathname
                }
            });
        } else {
            yield put({ type: VIEW_VERIFIED_VISIT_LOADING_END })
            message.error('Failed to view verified visit!');
        }
    } catch (error) {
        yield put({ type: VIEW_VERIFIED_VISIT_ERROR, error })
        message.error('Failed to view verified visit!');
    }
}

function* viewSubmittedToTypistVisit({ report }) {
    try {
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_STT_VISIT_LOADING_START })
        // const risUserName = yield getRisUserNameForRisId(report.risId);
        const { userId } = yield select(getAuthUserState);
        const { pathname } = yield select(getRoutingLocation);

        if (report.lockedBy == null) {
            const response = yield lockVisitAPI(report.reportId);
            if (response.success) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport
                        }
                    })
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mis/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR })
                message.error('Visit is locked by other user!');
            }
            yield put({ type: VIEW_STT_VISIT_LOADING_END })
        } else {
            if (report.lockedBy === userId) {
                const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
                if (visitReportResponse.success) {
                    yield put({
                        type: VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS,
                        report: {
                            ...visitReportResponse.visitReport
                        }
                    })
                    const data = {
                        risId: report.risId,
                        patientId: report.pid,
                        accessionNum: report.visitNo,
                        mipId: report.mipId
                    }
                    yield call(viewImages, data);
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: true,
                            reportId: report.reportId
                        }
                    })
                    history.push({
                        pathname: '/mis/report-viewer',
                        state: {
                            from: pathname
                        }
                    });
                } else {
                    message.error('Failed to view visit!');
                }
            } else {
                yield put({ type: VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR, error: null })
                message.error('Failed to view visit!');
            }
            yield put({ type: VIEW_STT_VISIT_LOADING_END })
        }
    } catch (error) {
        yield put({ type: VIEW_STT_VISIT_LOADING_END })
        yield put({ type: VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR, error })
        message.error('Failed to view visit!');
    }
}

const getMisActor = (userId, { mis1, mis2 }) => {
    let actor = null;
    if (!mis1 && !mis2) {
        actor = "MIS1";
    } else {
        if (mis1 === userId) {
            actor = "MIS1";
        } else if (mis2 === userId) {
            actor = "MIS2";
        }
        return actor;
    }
}

const showMessage = (userId, visit) => {
    const misActor = getMisActor(userId, visit);
    const { mis1, mis2, verify1, verify2 } = visit;
    if (misActor === "MIS1") {
        if (mis2 === null) {
            message.success("Report verified successfully.")
        } else {
            message.success("Report verified & sent to co-reporter.")
        }
    } else if (misActor === "MIS2") {
        if (verify1 === true) {
            message.success("Report verified successfully.");
        } else {
            message.success("Report verified & sent to mis1.");
        }
    }
}

function* updateVisitReportState({ payload }) {
    const { updateReportData, autoNextConfig } = payload;
    // const risUserName = yield getRisUserNameForRisId(updateReportData.risId);
    // if (!risUserName) {
    //     message.error(`Ris Username not found!`);
    //     return;
    // }
    const { userId } = yield select(getAuthUserState);
    try {
        yield put({ type: UPDATE_VISIT_REPORT_STATE_START })
        const response = yield call(updateVisitReportStateAPI, updateReportData);
        if (response.success) {
            if (response.visit.state === VISIT_STATES.H) {
                yield put({ type: RESET_REVIEWING_REPORT })
                yield put(setUnsavedChanges(false));
                message.success(`Report verified successfully.`);
                if (autoNextConfig.autoNextVisit) {
                    yield call(viewNextVisit, autoNextConfig, updateReportData);
                } else {
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: false,
                            reportId: null,
                        }
                    })
                    history.goBack();
                }
            } else {
                yield put(setUnsavedChanges(false))
                yield put({ type: UPDATE_VISIT_REPORT_STATE_SUCCESS, visit: { ...response.visit } })
                if (updateReportData.state === VISIT_STATES.H) {
                    yield call(showMessage, userId, response.visit);
                } else if (response.visit.state === VISIT_STATES.SFV) {
                    message.success(`Visit submitted for verification successfully`);
                } else {
                    message.success(`Report parked successfully`);
                }
                if (autoNextConfig.autoNextVisit) {
                    yield call(viewNextVisit, autoNextConfig, updateReportData);
                } else {
                    yield put({
                        type: SET_VISIT_LOCK,
                        selectedVisit: {
                            isVisitLocked: false,
                            reportId: null
                        }
                    })
                    if (updateReportData.state === VISIT_STATES.H) {
                        history.goBack();
                    }
                }
            }
        } else {
            const msg = updateReportData.state === VISIT_STATES.P ? "park" :
                updateReportData.state === VISIT_STATES.H ? "verify" : "park";
            if (response.error) {
                yield put({ type: UPDATE_VISIT_REPORT_STATE_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: UPDATE_VISIT_REPORT_STATE_ERROR, error: response.error })
                message.error(`Failed to ${msg} visit report!`);
            }
        }
    } catch (error) {
        yield put({ type: UPDATE_VISIT_REPORT_STATE_ERROR, error })
        message.error(`Failed to update report!`);
    }
}

function* fetchPatientHistoryReports({ visit }) {
    try {
        const { reportId: reportId, visitNo, patientId, } = visit;
        yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_START })
        const response = yield call(getPatientHistoryReportsAPI, patientId);
        if (response.success) {
            const filteredPatientHistoryReports = response.patientHistoryReports.filter(report => report.visit.reportId !== reportId && report.visit.visitNo !== visitNo);
            yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_SUCCESS, patientHistoryReports: filteredPatientHistoryReports })
        } else {
            yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_ERROR })
            message.error('Failed to fetch patient history reports!');
        }
    } catch (error) {
        yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_ERROR, error })
        message.error('Failed to fetch patient history reports!');
    }
}

function* unlockVisit({ payload }) {
    try {
        const { visit, onConfirm } = payload;
        yield put({ type: UNLOCK_VISIT_START })
        const response = yield call(unlockVisitAPI, visit.reportId);
        if (response.success) {
            yield put({ type: UNLOCK_VISIT_SUCCESS });
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            onConfirm();
        } else {
            yield put({ type: UNLOCK_VISIT_ERROR, error: response.error });
            onConfirm();
            if (response.error) {
                message.error(response.error);
            } else {
                message.error('Failed to unlock visit!');
            }
        }
    } catch (error) {
        yield put({ type: UNLOCK_VISIT_ERROR, error })
        message.error('Failed to unlock visit!');
    }
}

function* submitVisitReportDictation({ payload }) {
    try {
        const { dictation, autoNextConfig, dispatch } = payload;
        yield put({ type: SUBMIT_VISIT_REPORT_DICTATION_START })
        const response = yield call(submitVisitReportDictationAPI, dictation, dispatch);

        var reportViewerState = yield select(getReportViewerState);
        const { report } = reportViewerState;
        if (response.success) {
            if (report) {
                message.success('Dictation submitted successfully');
                yield put({
                    type: SUBMIT_VISIT_REPORT_DICTATION_SUCCESS,
                    report: {
                        ...report,
                        visit: { ...report.visit, lockedBy: null },
                        dictations: report.dictations
                    }
                })
                yield put({ type: SET_UNSAVED_CHANGES, unsavedChanges: false })
                if (autoNextConfig.autoNextVisit) {
                    yield call(viewNextVisit, autoNextConfig, dictation);
                } else {
                    history.goBack();
                }
            }
        } else {
            if (response.error) {
                yield put({ type: SUBMIT_VISIT_REPORT_DICTATION_ERROR, error: response.error });
                message.error(response.error);
            } else {
                yield put({ type: SUBMIT_VISIT_REPORT_DICTATION_ERROR, error: response.error });
                message.error('Failed to submit dictation!');
            }
        }

    } catch (error) {
        yield put({ type: SUBMIT_VISIT_REPORT_DICTATION_ERROR, error });
        message.error('Failed to submit dictation!');
    }
}

function* viewNextVisit({ prevLocation }, currentVisit = null) {
    switch (prevLocation) {
        case '/mis/worklist':
            yield call(viewWorklistNextVisit);
            break;
        case '/mis/submitted-for-verification':
            yield call(viewSubmittedForVerificationNextVisit);
            break;
        case '/mis/parked':
            yield call(viewParkedNextVisit, currentVisit);
            break;
        default:
            yield call(setVisitLock, null);
            history.goBack();
            break;
    }
}

function* viewParkedNextVisit(currentVisit = null) {
    try {
        yield put({ type: TICKET_DETAILS_RESET });
        yield put(resetReviewingReport());
        yield put(setUnsavedChanges(false));
        yield put({ type: VIEW_PARKED_VISIT_START });
        const parkedState = yield select(getParkedState);
        const sessionData = yield select(getSessionDataState);
        let skippedVisits = [];
        if (sessionData && sessionData.mis_p_skv) {
            skippedVisits = sessionData.mis_p_skv.map(v => v.reportId)
        }
        if (currentVisit && currentVisit.reportId && !skippedVisits.includes(currentVisit.reportId)) {
            skippedVisits = [...skippedVisits, currentVisit.reportId];
        }
        const request = {
            searchFilter: parkedState.searchFilter || initialSearch.searchFilter,
            sortConditions: parkedState.sortConditions || initialSearch.sortConditions,
            skippedVisits,
            page: parkedState.pagination.currentPage,
            size: parkedState.pagination.pageSize,
        };
        const response = yield call(getAutoNextParkedVisitAPI, request);
        //console.log('[parked-auto-next] response', JSON.stringify(response));
        const nextReport = response.report;
        const hasNextReport = !!(nextReport && nextReport.visit);
        //console.log('[parked-auto-next] nextReport visit?', hasNextReport, 'keys:', nextReport ? Object.keys(nextReport) : null);
        if (response.success) {
            if (hasNextReport) {
                yield put({ type: VIEW_PARKED_VISIT_SUCCESS, report: nextReport });
                yield call(viewImages, {
                    risId: nextReport.visit.risId,
                    patientId: nextReport.patient ? nextReport.patient.pid : null,
                    accessionNum: nextReport.visit.visitNo,
                    mipId: nextReport.visit.mipId
                });
                return;
            }
            message.info("Next visit not found!");
            yield put({ type: VIEW_PARKED_VISIT_ERROR, error: null });
            history.push('/mis/parked');
        } else {
            yield put({ type: VIEW_PARKED_VISIT_ERROR, error: response.error })
            message.error(response.error || 'Failed to view next visit!');
            history.push('/mis/parked');
        }
    } catch (error) {
        yield put({ type: VIEW_PARKED_VISIT_ERROR, error })
        message.error('Failed to view next visit!');
        history.push('/mis/parked');
    }
}

function* viewWorklistNextVisit() {
    try {
        yield put({ type: TICKET_DETAILS_RESET });
        yield put(resetReviewingReport());
        yield put(setUnsavedChanges(false));
        yield put({ type: VIEW_WORKLIST_VISIT_START });
        const worklistState = yield select(getWorklistState);
        const sessionData = yield select(getSessionDataState);
        let skippedVisits = [];
        if (sessionData && sessionData.mis_fr_skv) {
            skippedVisits = sessionData.mis_fr_skv.map(v => v.reportId)
        }
        const request = {
            searchFilter: worklistState.searchFilter || initialSearch.searchFilter,
            sortConditions: worklistState.sortConditions || initialSearch.sortConditions,
            skippedVisits,
            page: worklistState.pagination.currentPage,
            size: worklistState.pagination.pageSize,
        }
        const response = yield call(getWorklistAutoNextVisitAPI, request);
        if (response.success) {
            let visit = response.report.visit;
            if (response.report) {
                yield put({
                    type: VIEW_WORKLIST_VISIT_SUCCESS,
                    report: response.report
                })
                const data = {
                    risId: response.report.visit.risId,
                    patientId: response.report.patient.pid,
                    accessionNum: response.report.visit.visitNo,
                    mipId: response.report.visit.mipId
                }
                yield call(viewImages, data);
                if (visit && visit.lockedBy !== null) {
                    yield call(setVisitLock, visit);
                } else {
                    yield call(setVisitLock, null);
                }
            } else {
                message.info("Next visit not found!");
                yield call(setVisitLock, null);
                history.goBack();
            }
        } else {
            if (response.error) {
                yield put({ type: VIEW_WORKLIST_VISIT_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: VIEW_WORKLIST_VISIT_ERROR, error: response.error })
                message.error('Failed to view next visit!');
            }
            yield call(setVisitLock, null);
            history.goBack();
        }
    } catch (error) {
        yield put({ type: VIEW_WORKLIST_VISIT_ERROR, error })
        message.error('Failed to view next visit!');
        yield call(setVisitLock, null);
        history.goBack();
    }
}

function* viewSubmittedForVerificationNextVisit() {
    try {
        yield put({ type: TICKET_DETAILS_RESET });
        yield put(resetReviewingReport());
        yield put(setUnsavedChanges(false));
        yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START });
        const submittedForVerificationState = yield select(getSubmittedForVerificationState);
        const sessionData = yield select(getSessionDataState);
        let skippedVisits = [];
        if (sessionData && sessionData.mis_sfv_skv) {
            skippedVisits = sessionData.mis_sfv_skv.map(v => v.reportId)
        }
        const request = {
            searchFilter: submittedForVerificationState.searchFilter || initialSearch.searchFilter,
            sortConditions: submittedForVerificationState.sortConditions || initialSearch.sortConditions,
            skippedVisits,
            page: submittedForVerificationState.pagination.currentPage,
            size: submittedForVerificationState.pagination.pageSize,
        }
        const response = yield call(getsubmittedForVerificationAutoNextVisitAPI, request);
        if (response.success) {
            if (response.report) {
                yield put({
                    type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
                    report: response.report
                })
                const data = {
                    risId: response.report.visit.risId,
                    patientId: response.report.patient.pid,
                    accessionNum: response.report.visit.visitNo,
                    mipId: response.report.visit.mipId
                }
                const autoLaunchViewer = yield call(shouldAutoLaunchViewerOnSfv);
                if(autoLaunchViewer && response.report.visit.mis1 === null){
                    yield call(viewImages, data);
                }
                let visit = response.report.visit;
                if (visit && visit.lockedBy !== null) {
                    yield call(setVisitLock, visit);
                } else {
                    yield call(setVisitLock, null);
                }
            } else {
                yield call(setVisitLock, null);
                message.info("Next visit not found!");
                history.goBack();
            }
        } else {
            if (response.error) {
                yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error: response.error })
                message.error('Failed to view next visit!');
            }
            yield call(setVisitLock, null);
            history.goBack();
        }
    } catch (error) {
        yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error })
        message.error('Failed to view next visit!');
        yield call(setVisitLock, null);
        history.goBack();
    }
}

function* skipCurrentAndLoadNextVisit({ payload }) {
    try {

        const { email, userId } = yield select(getAuthUserState);
        const sessionData = yield select(getSessionDataState);
        const { visit, autoNextConfig } = payload;
        const { reportId, risId, risCode, visitNo } = visit;
        const isParkedVisit = autoNextConfig.prevLocation === '/mis/parked' || autoNextConfig.isParkedVisit;
        const isLocked = visit.lockedBy != null && visit.lockedBy !== '';
        const shouldUnlockVisit = isLocked && (!isParkedVisit || visit.lockedBy === userId);
        let response = { success: true };
        if (shouldUnlockVisit) {
            yield put({ type: UNLOCK_VISIT_START })
            response = yield call(unlockVisitAPI, reportId);
        }
        if (response.success) {
            if (shouldUnlockVisit) {
                yield put({ type: UNLOCK_VISIT_SUCCESS });
            }
            if (autoNextConfig.autoNextVisit) {
                let data;
                let payload;
                let skv;
                let index = -1;
                switch (autoNextConfig.prevLocation) {
                    case '/mis/worklist':
                        const { mis_fr_skv } = sessionData;
                        skv = {
                            "reportId": reportId,
                            "visitNo": visitNo,
                            "risId": risId,
                            "risCode": risCode,
                        };
                        if (mis_fr_skv) {
                            index = mis_fr_skv.findIndex(v => v.reportId === reportId);
                            if (index < 0) {
                                data = [...mis_fr_skv, skv];
                            } else {
                                data = [...mis_fr_skv];
                            }
                        } else {
                            data = [skv];
                        }
                        payload = {
                            key: 'mis_fr_skv',
                            value: data
                        };
                        setSessionDataByKey(email, payload);
                        yield put({ type: SET_USER_SESSION_DATA_BY_KEY, payload });
                        yield call(viewNextVisit, autoNextConfig, visit);
                        break;
                    case '/mis/submitted-for-verification':
                        const { mis_sfv_skv } = sessionData;
                        skv = {
                            "reportId": reportId,
                            "visitNo": visitNo,
                            "risId": risId,
                            "risCode": risCode,
                        };
                        if (mis_sfv_skv) {
                            index = mis_sfv_skv.findIndex(v => v.reportId === reportId);
                            if (index < 0) {
                                data = [...mis_sfv_skv, skv];
                            } else {
                                data = [...mis_sfv_skv];
                            }
                        } else {
                            data = [skv];
                        }
                        payload = {
                            key: 'mis_sfv_skv',
                            value: data
                        };
                        setSessionDataByKey(email, payload);
                        yield put({ type: SET_USER_SESSION_DATA_BY_KEY, payload });
                        yield call(viewNextVisit, autoNextConfig, visit);
                        break;
                    case '/mis/parked':
                        const { mis_p_skv } = sessionData;
                        skv = {
                            "reportId": reportId,
                            "visitNo": visitNo,
                            "risId": risId,
                            "risCode": risCode,
                        };
                        if (mis_p_skv) {
                            index = mis_p_skv.findIndex(v => v.reportId === reportId);
                            if (index < 0) {
                                data = [...mis_p_skv, skv];
                            } else {
                                data = [...mis_p_skv];
                            }
                        } else {
                            data = [skv];
                        }
                        payload = {
                            key: 'mis_p_skv',
                            value: data
                        };
                        setSessionDataByKey(email, payload);
                        yield put({ type: SET_USER_SESSION_DATA_BY_KEY, payload });
                        yield call(viewNextVisit, autoNextConfig, visit);
                        break;
                    default:
                        break;
                }
            } else {
                yield put({
                    type: SET_VISIT_LOCK,
                    selectedVisit: {
                        isVisitLocked: false,
                        reportId: null
                    }
                })
                history.goBack();
            }
        } else {
            if (response.error) {
                message.error(response.error);
                yield put({ type: UNLOCK_VISIT_ERROR, error: response.error })
            } else {
                message.error(`Failed to unlock visit ${visitNo}!`);
            }
        }
    } catch (error) {
        console.log(error);
        yield put({ type: UNLOCK_VISIT_ERROR, error })
        message.error('Failed to unlock visit!');
    }
}

function* viewImages(payload) {
    try {
        const { imageViewer, orderLoaded } = yield select(getIntegratorState);
        switch (imageViewer) {
            case IMAGE_VIEWERS.INTELEVIEWER:
                yield put(loadOrder(payload));
                break;
            case IMAGE_VIEWERS.ORTHANC:
                // view images using orthanc
                break;
            default:
                break;
        }
    } catch (error) {
        console.log(error);
    }
}

function* unassignMis1({ reportId }) {
    try {
        yield put({ type: UNASSIGN_MIS1_START });
        const response = yield call(unassignMis1API, reportId);
        if (response.success) {
            yield put({ type: UNASSIGN_MIS1_SUCCESS, visit: response.visit });
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            history.goBack();
        } else {
            yield put({ type: UNASSIGN_MIS1_ERROR });
            message.error('Failed to unassign mis1!');
        }
    } catch (error) {
        console.log(error);
        yield put({ type: UNASSIGN_MIS1_ERROR });
    }
}

function* assignedMis2ToVisit({ payload }) {
    try {
        const response = yield call(assignedMis2API, payload);
        if (response.success) {
            yield put({ type: ASSIGN_MIS2_TO_VISIT_SUCCESS, visit: { ...response.data } })
        } else {
            // yield put({ type: ASSIGN_MIS2_TO_VISIT_ERROR })
        }

    } catch (error) {
        message.error('Failed to assign co-reporter to visit!');
    }
}

function* saveDictationAudio({ payload }) {
    try {
        const { dictation, dispatch } = payload;
        const response = yield call(saveDictationAudioAPI, dictation, dispatch);
        const { report } = yield select(getReportViewerState);
        if (response.success) {
            yield put({ type: SAVE_DICTATION_AUDIO_SUCCESS })
            yield put({
                type: SUBMIT_VISIT_REPORT_DICTATION_SUCCESS,
                report: {
                    ...report,
                    dictations: response.success ? [response.data] : []
                }
            })
        } else {
            yield put({ type: SAVE_DICTATION_AUDIO_ERROR })
        }
    } catch (error) {
        yield put({ type: SAVE_DICTATION_AUDIO_ERROR })
        message.error('Failed to save dictation audio!');
    }
}

function* updateStudy({ payload }) {
    try {
        const response = yield call(updateStudyAPI, payload);

        yield put({ type: SUBMIT_START })

        if (response.success) {
            message.success('Update study successfully.');

            yield put({ type: UPDATE_STUDY_SUCCESS, visit: payload })
            yield put({ type: HIDE_MODAL })

        } else {
            yield put({ type: SUBMIT_ERROR })
        }
    } catch (error) {
        yield put({ type: SUBMIT_ERROR })
        message.error('Failed to update study!');
    }
}



function* reportViewerWatcher() {
    yield takeLatest(VIEW_WORKLIST_VISIT, viewWorklistVisit)
    yield takeLatest(VIEW_SUBMITTED_FOR_VERIFICATION_VISIT, viewSubmittedForVerificationVisit)
    yield takeLatest(VIEW_PARKED_VISIT, viewParkedVisit)
    yield takeLatest(VIEW_VERIFIED_VISIT, viewVerifiedVisit)
    yield takeLatest(VIEW_SUBMITTED_TO_TYPIST_VISIT, viewSubmittedToTypistVisit)
    yield takeLatest(UPDATE_VISIT_REPORT_STATE, updateVisitReportState)
    yield takeLatest(FETCH_PATIENT_HISTORY_REPORTS, fetchPatientHistoryReports)
    yield takeLatest(UNLOCK_VISIT, unlockVisit)
    yield takeLatest(SUBMIT_VISIT_REPORT_DICTATION, submitVisitReportDictation)
    yield takeLatest(SAVE_DICTATION_AUDIO, saveDictationAudio)
    yield takeLatest(SKIP_CURRENT_AND_VIEW_NEXT_VISIT, skipCurrentAndLoadNextVisit)
    yield takeLatest(UNASSIGN_MIS1, unassignMis1)
    yield takeLatest(ASSIGN_MIS2_TO_VISIT, assignedMis2ToVisit)
    yield takeLatest(UPDATE_STUDY, updateStudy)
    yield takeLatest(LOCK_VERIFIED_VISIT, lockVerifiedVisit)
}

function* handleOpenVoyager({ accessionNumber }) {
    try {
        yield call(openVoyagerAPI, accessionNumber);
    } catch (err) {
        
    }
}

function* handleCloseVoyager({ accessionNumber, isReported }) {
    try {
        yield call(closeVoyagerAPI, accessionNumber, isReported);
    } catch (err) {
        
    }
}

function* voyagerSaga() {
    yield takeEvery(OPEN_VOYAGER_STUDY, handleOpenVoyager);
    yield takeEvery(CLOSE_VOYAGER_STUDY, handleCloseVoyager);
}

export default function* rootSaga() {
    yield all([
        reportViewerWatcher(),
        voyagerSaga(),
    ]);
}


